/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DigitizingMelcoDigitizingModelsEmbroideryColor,
    DigitizingMelcoDigitizingModelsEmbroideryColorFromJSON,
    DigitizingMelcoDigitizingModelsEmbroideryColorFromJSONTyped,
    DigitizingMelcoDigitizingModelsEmbroideryColorToJSON,
    DigitizingMelcoDigitizingModelsOrderAlert,
    DigitizingMelcoDigitizingModelsOrderAlertFromJSON,
    DigitizingMelcoDigitizingModelsOrderAlertFromJSONTyped,
    DigitizingMelcoDigitizingModelsOrderAlertToJSON,
    DigitizingMelcoDigitizingModelsOrderCompletedFile,
    DigitizingMelcoDigitizingModelsOrderCompletedFileFromJSON,
    DigitizingMelcoDigitizingModelsOrderCompletedFileFromJSONTyped,
    DigitizingMelcoDigitizingModelsOrderCompletedFileToJSON,
} from './';

/**
 * 
 * @export
 * @interface DigitizingMelcoDigitizingModelsOrderResponse
 */
export interface DigitizingMelcoDigitizingModelsOrderResponse {
    /**
     * 
     * @type {number}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    template_id?: number;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    height?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    width?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    instructions?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    is_same_day_order?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    promo_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    customer_user_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    measurement_unit?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    client_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    po_number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    garment_type_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    garment_type_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    position_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    position_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    color_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    color_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    color_hex_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    delivery_option_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    delivery_option_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    delivery_hours?: number;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    error_message?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    actual_stitch_count?: number;
    /**
     * 
     * @type {number}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    final_stitch_count?: number;
    /**
     * 
     * @type {Array<DigitizingMelcoDigitizingModelsOrderCompletedFile>}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    completed_files?: Array<DigitizingMelcoDigitizingModelsOrderCompletedFile> | null;
    /**
     * 
     * @type {Array<DigitizingMelcoDigitizingModelsOrderAlert>}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    alerts?: Array<DigitizingMelcoDigitizingModelsOrderAlert> | null;
    /**
     * 
     * @type {Array<DigitizingMelcoDigitizingModelsEmbroideryColor>}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    embroidery_colors?: Array<DigitizingMelcoDigitizingModelsEmbroideryColor> | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    order_reference_number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    design_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    order_status?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    created_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof DigitizingMelcoDigitizingModelsOrderResponse
     */
    is_payment_done?: boolean;
}

export function DigitizingMelcoDigitizingModelsOrderResponseFromJSON(json: any): DigitizingMelcoDigitizingModelsOrderResponse {
    return DigitizingMelcoDigitizingModelsOrderResponseFromJSONTyped(json, false);
}

export function DigitizingMelcoDigitizingModelsOrderResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingMelcoDigitizingModelsOrderResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'template_id': !exists(json, 'template_id') ? undefined : json['template_id'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'width': !exists(json, 'width') ? undefined : json['width'],
        'instructions': !exists(json, 'instructions') ? undefined : json['instructions'],
        'is_same_day_order': !exists(json, 'is_same_day_order') ? undefined : json['is_same_day_order'],
        'promo_code': !exists(json, 'promo_code') ? undefined : json['promo_code'],
        'customer_user_name': !exists(json, 'customer_user_name') ? undefined : json['customer_user_name'],
        'measurement_unit': !exists(json, 'measurement_unit') ? undefined : json['measurement_unit'],
        'client_name': !exists(json, 'client_name') ? undefined : json['client_name'],
        'po_number': !exists(json, 'po_number') ? undefined : json['po_number'],
        'garment_type_id': !exists(json, 'garment_type_id') ? undefined : json['garment_type_id'],
        'garment_type_name': !exists(json, 'garment_type_name') ? undefined : json['garment_type_name'],
        'position_id': !exists(json, 'position_id') ? undefined : json['position_id'],
        'position_name': !exists(json, 'position_name') ? undefined : json['position_name'],
        'color_id': !exists(json, 'color_id') ? undefined : json['color_id'],
        'color_name': !exists(json, 'color_name') ? undefined : json['color_name'],
        'color_hex_code': !exists(json, 'color_hex_code') ? undefined : json['color_hex_code'],
        'delivery_option_id': !exists(json, 'delivery_option_id') ? undefined : json['delivery_option_id'],
        'delivery_option_name': !exists(json, 'delivery_option_name') ? undefined : json['delivery_option_name'],
        'delivery_hours': !exists(json, 'delivery_hours') ? undefined : json['delivery_hours'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'error_message': !exists(json, 'error_message') ? undefined : json['error_message'],
        'actual_stitch_count': !exists(json, 'actual_stitch_count') ? undefined : json['actual_stitch_count'],
        'final_stitch_count': !exists(json, 'final_stitch_count') ? undefined : json['final_stitch_count'],
        'completed_files': !exists(json, 'completed_files') ? undefined : (json['completed_files'] === null ? null : (json['completed_files'] as Array<any>).map(DigitizingMelcoDigitizingModelsOrderCompletedFileFromJSON)),
        'alerts': !exists(json, 'alerts') ? undefined : (json['alerts'] === null ? null : (json['alerts'] as Array<any>).map(DigitizingMelcoDigitizingModelsOrderAlertFromJSON)),
        'embroidery_colors': !exists(json, 'embroidery_colors') ? undefined : (json['embroidery_colors'] === null ? null : (json['embroidery_colors'] as Array<any>).map(DigitizingMelcoDigitizingModelsEmbroideryColorFromJSON)),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'order_reference_number': !exists(json, 'order_reference_number') ? undefined : json['order_reference_number'],
        'design_name': !exists(json, 'design_name') ? undefined : json['design_name'],
        'order_status': !exists(json, 'order_status') ? undefined : json['order_status'],
        'created_date': !exists(json, 'created_date') ? undefined : (json['created_date'] === null ? null : new Date(json['created_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'is_payment_done': !exists(json, 'is_payment_done') ? undefined : json['is_payment_done'],
    };
}

export function DigitizingMelcoDigitizingModelsOrderResponseToJSON(value?: DigitizingMelcoDigitizingModelsOrderResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'template_id': value.template_id,
        'height': value.height,
        'width': value.width,
        'instructions': value.instructions,
        'is_same_day_order': value.is_same_day_order,
        'promo_code': value.promo_code,
        'customer_user_name': value.customer_user_name,
        'measurement_unit': value.measurement_unit,
        'client_name': value.client_name,
        'po_number': value.po_number,
        'garment_type_id': value.garment_type_id,
        'garment_type_name': value.garment_type_name,
        'position_id': value.position_id,
        'position_name': value.position_name,
        'color_id': value.color_id,
        'color_name': value.color_name,
        'color_hex_code': value.color_hex_code,
        'delivery_option_id': value.delivery_option_id,
        'delivery_option_name': value.delivery_option_name,
        'delivery_hours': value.delivery_hours,
        'status': value.status,
        'error_message': value.error_message,
        'actual_stitch_count': value.actual_stitch_count,
        'final_stitch_count': value.final_stitch_count,
        'completed_files': value.completed_files === undefined ? undefined : (value.completed_files === null ? null : (value.completed_files as Array<any>).map(DigitizingMelcoDigitizingModelsOrderCompletedFileToJSON)),
        'alerts': value.alerts === undefined ? undefined : (value.alerts === null ? null : (value.alerts as Array<any>).map(DigitizingMelcoDigitizingModelsOrderAlertToJSON)),
        'embroidery_colors': value.embroidery_colors === undefined ? undefined : (value.embroidery_colors === null ? null : (value.embroidery_colors as Array<any>).map(DigitizingMelcoDigitizingModelsEmbroideryColorToJSON)),
        'id': value.id,
        'order_reference_number': value.order_reference_number,
        'design_name': value.design_name,
        'order_status': value.order_status,
        'created_date': value.created_date === undefined ? undefined : (value.created_date === null ? null : value.created_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'is_payment_done': value.is_payment_done,
    };
}


